import { render, staticRenderFns } from "./ProductServiceSelector.vue?vue&type=template&id=3f48768a&scoped=true"
import script from "./ProductServiceSelector.vue?vue&type=script&lang=js"
export * from "./ProductServiceSelector.vue?vue&type=script&lang=js"
import style0 from "./ProductServiceSelector.vue?vue&type=style&index=0&id=3f48768a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_j7knk6mol3vthgvrc443rvn57u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f48768a",
  null
  
)

export default component.exports